export default {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID || "",
  dataset: process.env.GATSBY_SANITY_DATASET || ""
};
